import type { IScope } from "angular";

import type { IDataRetention, IResponseWithLoading, ISite } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";
import { finalize } from "rxjs/operators";

export default class DataPolicyComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository", "mmModalService"];

    public site: IResponseWithLoading<ISite>;

    public partnerDataRetention: IResponseWithLoading<IDataRetention>;

    public isLoading: boolean;

    public showAlarmVideoLength = false;

    constructor(
        private readonly $scope: IScope,
        private readonly sitesRepository: ISitesRepository,
        private readonly modalService: IModalService,
    ) {}

    public $onChanges() {
        this.isLoading = true;

        if (this.site && this.site.data) {
            extendWithLoadingAndFail(this.sitesRepository.getGlobalDataRetention(this.site.data.id))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response) => {
                        if (!response.isLoading) {
                            if (!response.hasError) {
                                this.partnerDataRetention = response;
                            }
                            this.isLoading = false;
                        }
                    },
                    (error) => {
                        this.partnerDataRetention = error;
                        this.isLoading = false;
                    },
                );
        }
    }

    public editDataPolicySettings() {
        this.modalService
            .open<IDataRetention, { site: ISite; partnerDataRetention: IDataRetention }>(
                "irEditSiteDataPolicySettings",
                this.site.data.dataRetention,
                {
                    partnerDataRetention: this.partnerDataRetention.data,
                    site: this.site.data,
                },
            )
            .subscribe(
                (editResponse) => {
                    this.site.data.dataRetention = editResponse;
                },
                (reason) => reason,
            );
    }
}
